export const pageUsageTypes = {
  HOSTED: 'hosted',
  SITE: 'site',
};
